import { FaStar, FaRegStar } from 'react-icons/fa';
import { MdOutlineMarkEmailUnread, MdMarkEmailUnread } from 'react-icons/md';
import type { FileFilters } from '../../../../types/file.types';
import TrashRestore from '@/components/icons/TrashRestore';
import TrashRestoreOutline from '@/components/icons/TrashRestoreOutline';
import { IconButton } from '@/components/ui/IconButton';

interface QuickFiltersProps {
  filters: FileFilters[];
  handleToggleFilter: (filter: FileFilters) => void;
}

export const QuickFilters = ({
  filters,
  handleToggleFilter,
}: QuickFiltersProps) => {
  return (
    <div className="flex items-center space-x-2">
      <IconButton
        onClick={() => handleToggleFilter('isFavorite')}
        icon={
          filters.includes('isFavorite') ? (
            <FaStar className="text-lg transition-transform duration-300 ease-in-out" />
          ) : (
            <FaRegStar className="text-lg transition-transform duration-300 ease-in-out" />
          )
        }
        tooltipContent={
          filters.includes('isFavorite')
            ? 'Masquer les favoris'
            : 'Afficher les favoris'
        }
        isActive={filters.includes('isFavorite')}
      />

      <IconButton
        onClick={() => handleToggleFilter('isUnread')}
        icon={
          filters.includes('isUnread') ? (
            <MdMarkEmailUnread className="text-lg transition-transform duration-300 ease-in-out" />
          ) : (
            <MdOutlineMarkEmailUnread className="text-lg transition-transform duration-300 ease-in-out" />
          )
        }
        tooltipContent={
          filters.includes('isUnread')
            ? 'Masquer les non lus'
            : 'Afficher les non lus'
        }
        tooltipPlace="bottom"
        isActive={filters.includes('isUnread')}
      />

      <IconButton
        onClick={() => handleToggleFilter('isArchived')}
        tooltipContent={
          filters.includes('isArchived')
            ? 'Masquer les archivés'
            : 'Afficher les archivés'
        }
        icon={
          filters.includes('isArchived') ? (
            <TrashRestore className="text-lg transition-transform duration-300 ease-in-out" />
          ) : (
            <TrashRestoreOutline className="text-lg transition-transform duration-300 ease-in-out" />
          )
        }
        isActive={filters.includes('isArchived')}
      />
    </div>
  );
};
